var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppFaxThatSheetLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-05cv1jyrij-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF9FF",
    offset: "24.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE9FF",
    offset: "56.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCEFF",
    offset: "93.17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C8FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing_03",
    transform: "translate(-220.000000, -1184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "present_01",
    transform: "translate(0.000000, 1000.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(220.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5416B0",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0174166,62.1943735 L42.4648348,67.9629224 C41.2491616,68.2032786 39.7903537,67.2418538 39.547219,66.0400727 L31.0375062,18.6899009 C30.7943716,17.4881199 31.7669102,16.0459827 32.9825834,15.8056265 L66.5351652,10.0370776 C67.7508384,9.79672143 69.2096463,10.7581462 69.452781,11.9599273 L77.9624938,59.3100991 C78.2056284,60.7522363 77.2330898,61.9540173 76.0174166,62.1943735 Z",
    id: "Path",
    fill: "#7E4EC1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6330531,72.9633464 L44.9656559,65.5975098 C43.7603622,65.3599021 42.7961273,64.171864 43.037186,62.7462182 L51.474242,15.9375147 C51.7153007,14.7494765 52.9205944,13.799046 54.3669469,14.0366536 L97.0343441,21.4024902 C98.2396378,21.6400979 99.2038727,22.828136 98.962814,24.2537818 L90.525758,71.0624853 C90.0436406,72.2505235 88.8383469,73.200954 87.6330531,72.9633464 Z",
    id: "Path",
    fill: "#A989D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0153501,69.7344879 L32.4274005,78.9625387 C31.2156966,79.2053821 29.7616519,78.2340084 29.5193111,77.0197912 L21.0373838,29.1796334 C20.795043,27.9654161 21.7644061,26.5083555 22.97611,26.2655121 L75.5640596,17.0374613 C76.7757635,16.7946179 78.2298082,17.7659916 78.472149,18.9802088 L86.9540763,66.8203666 C87.1964171,68.2774273 86.4693948,69.4916445 85.0153501,69.7344879 Z",
    id: "Path",
    fill: "#C3ACE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,86.15625 L94,30.8125 C94,28.165625 91.8464286,26 89.2142857,26 L31.7857143,26 C29.1535714,26 27,28.165625 27,30.8125 L27,98.1875 C27,100.834375 29.1535714,103 31.7857143,103 L77.25,103 L94,86.15625 Z",
    id: "Path",
    fill: "url(#linearGradient-05cv1jyrij-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 41.000000)",
    fill: "#5313AD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.6969697 0.24137931 9.6969697 3.62068966 4.36363636 3.62068966 4.36363636 5.55172414 8.24242424 5.55172414 8.24242424 8.68965517 4.36363636 8.68965517 4.36363636 13.7586207 0 13.7586207 0 0 9.6969697 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8787879,11.8275862 L15.2727273,11.8275862 L14.5454545,13.7586207 L9.93939394,13.7586207 L15.030303,0 L19.8787879,0 L24.969697,13.7586207 L20.3636364,13.7586207 L19.8787879,11.8275862 Z M18.9090909,8.68965517 L17.6969697,4.82758621 L16.4848485,8.68965517 L18.9090909,8.68965517 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "34.6666667 13.7586207 32.2424242 10.137931 30.0606061 13.7586207 25.2121212 13.7586207 29.8181818 6.75862069 25.2121212 0.24137931 30.3030303 0.24137931 32.7272727 3.62068966 34.6666667 0.24137931 39.5151515 0.24137931 35.1515152 7.24137931 40 14 34.6666667 14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.8125,69 L42.1875,69 C41.475,69 41,68.6 41,68 L41,68 C41,67.4 41.475,67 42.1875,67 L77.8125,67 C78.525,67 79,67.4 79,68 L79,68 C79,68.6 78.525,69 77.8125,69 Z",
    id: "Path",
    fill: "#5313AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8125,79 L42.1875,79 C41.475,79 41,78.6 41,78 L41,78 C41,77.4 41.475,77 42.1875,77 L77.8125,77 C78.525,77 79,77.4 79,78 L79,78 C79,78.6 78.525,79 77.8125,79 Z",
    id: "Path",
    fill: "#5313AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8125,89 L42.1875,89 C41.475,89 41,88.6 41,88 L41,88 C41,87.4 41.475,87 42.1875,87 L58.8125,87 C59.525,87 60,87.4 60,88 L60,88 C60,88.6 59.525,89 58.8125,89 Z",
    id: "Path",
    fill: "#5313AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8F66CA",
    fillRule: "nonzero",
    points: "94 86 77 86 77 103"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppFaxThatSheetLogo);
export default __webpack_public_path__ + "static/media/appFaxThatSheetLogo.90bde202d68eb1f6e448bd3570f74017.svg";
export { ForwardRef as ReactComponent };